// extracted by mini-css-extract-plugin
export var container = "_4q-0";
export var disabled = "_4q-4";
export var fullWidth = "_4q-3";
export var lined = "_4q-1";
export var selected = "_4q-5";
export var tab = "_4q-2";